import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { RouteContext } from "../../contexts/RoutesContext";
import { Colour, UserType } from "../Variables";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { API_GetPositionDetails, API_GetPositionOverview, API_PositionCreateOrRedirectCheck, PositionContainerModel, PositionDetailsModel } from "../../apis/ApisPositions";
import { CardDivider } from "../components/Shared/CardDivider";
import { LoadingContent } from "../components/Shared/LoadingContent";
import { ForwardToAFriendForm } from "../components/Forms/ForwardToAFriendForm";
import { Loading } from "../components/Shared/Loading";
import { CreateApplicationCard } from "../components/Positions/CreateApplicationCard";
import { PositionLoginPromptPopup } from "../components/Positions/PositionLoginPromptPopup";

export type PositionDetailsProps = {
    intra: boolean,
}

export function PositionDetails(props: PositionDetailsProps) {
    const app = useContext(AppContext);
    const [queryParameters] = useSearchParams();
    let refId = queryParameters.get("id");
    let aref = queryParameters.get("aref");
    let jb = queryParameters.get("jb");
    let ddsb = queryParameters.get("ddsb");
    let n = queryParameters.get("n");
    const [position, setPosition] = useState<PositionDetailsModel>(null);
    const [redirectChecking, setRedirectChecking] = useState<boolean>(false);
    const [forwardToAFriend, setForwardToAFriend] = useState<boolean>(false);
    const [positionFullDetails, setPositionContainerModel] = useState<PositionContainerModel>(null);
    const [existingToCopy, setExistingToCopy] = useState<number | null>(null);
    const [loadingDetails, setLoadingDetails] = useState<boolean>(true);
    let navigate = useNavigate();

    const routeContext = useContext(RouteContext);
    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        async function asyncCall() {
            if (props.intra) {
                var positions = await API_GetPositionOverview(app.token, true);
                setPosition(positions.Positions.find(x => x.ApplyingForID.toString() == refId))
            }
            else {
                var match = app.positions.Positions.find(x => x.ApplyingForID.toString() == refId);
                if (match == null) {
                    navigate(`/`);
                }

                setPosition(match)
            }

            if (!app.loading && app.baseFeatures.IsIntranetDisplay && props.intra) {
                routeContext.setRoutes([{ name: "Intranet positions", route: "Intranet" }, { name: "Position details", route: null }]);
            }
            else {
                routeContext.setRoutes([{ name: "Position details", route: null }]);
            }
        }

        if (!app.loading) {
            asyncCall();
        }
    }, [app.loading]);

    useEffect(() => {
        if (!loadingDetails)
            getPositionDetails();

        if (!app.userLoggedIn) {
            setExistingToCopy(null);
            if (positionFullDetails != null)
                setPositionContainerModel({ ...positionFullDetails, ExistingApplications: [] });
        }
    }, [app.loggedInUser]);


    const loadData = async () => {
        setLoadingDetails(true);
        try {
            await getPositionDetails();
        } catch (error) {

        } finally {
            setLoadingDetails(false);
        }
    }

    const getPositionDetails = async () => {
        var positionData = await API_GetPositionDetails(refId, jb, ddsb, aref, app.token, props.intra);
        setPositionContainerModel(positionData);
        return positionData;
    }

    if (app.userLoggedIn)
        console.log(app?.loggedInUser);

    const completedLoginCallback = async (doLogic: boolean) => {
        if(!doLogic)
            return;

        function delay(ms: number) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        if (!loadingDetails)
            var res = await getPositionDetails();

        await delay(100);

        if (res.ExistingApplications.length == 0) {
            redirectOrCreateCheck();
        }
        else {
            document.getElementById("createApplicationCard")?.scrollIntoView();
        }
    }

    const redirectOrCreateCheck = async () => {
        if (!redirectChecking) {
            setRedirectChecking(true);
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            await API_PositionCreateOrRedirectCheck({ Aref: aref, ExistingToCopyID: existingToCopy, RefID: position.ApplyingForID, returl: null, Token: app.token, IntranetReq: props.intra, Name: n });
        }
    }

    const collapseButton = useRef<HTMLButtonElement>(null);

    if (app.loading || position == null)
        return null;

    return (
        <>
            <InfoBanner
                header={`${position.CandidateTitle}`}
                narrow={true}
                icon={InfoHeaderIcon.None}
                info={null}
                subHeader={`${position.ExternalDepartment}, ${position.LocationText}`}
                theme={Colour.White}>
            </InfoBanner>

            <PositionLoginPromptPopup onCompleteCallback={completedLoginCallback} applyingForID={position?.ApplyingForID} candidateTitle={position?.CandidateTitle} speculative={false} intranet={props.intra} />

            {redirectChecking && <div className="alert alert-success"><p className="text-center"><b>Creating new application</b></p><Loading classes={"row col-12 text-center"} /></div>}

            <div className="card shadow card-secondary mt-4 mb-3">
                <div className="card-header d-flex justify-content-between">
                    <span></span>
                    Position details
                    {(!app.userLoggedIn || app.loggedInUser.UserType == UserType.Candidate) && positionFullDetails?.CanForwardToFriend ? <button ref={collapseButton} disabled={loadingDetails} title="Forward to a friend" onClick={() => setForwardToAFriend(!forwardToAFriend)} data-bs-target={`#bdyCollapse_ForwardToAFriendForm`} data-bs-toggle="collapse" className={`card-mini-button-f2f me-0 align-content-center fa-solid ${!forwardToAFriend ? "fa-share-nodes" : "fa-chevron-up"} `}></button> : <span></span>}
                </div>
                <div className="">{positionFullDetails?.CanForwardToFriend && <ForwardToAFriendForm id={position.ApplyingForID} finished={() => {
                    collapseButton?.current?.click();
                }}></ForwardToAFriendForm>}</div>
                <div className="card-body extra-central-padding min-height-200px">
                    <LoadingContent loading={loadingDetails} classes={""}>
                        <CardDivider key={`SectionHeader_Main`} title={"Main information"} icon={"fa-solid fa-briefcase"} />
                        {positionFullDetails != null && positionFullDetails.Details != null &&
                            <ul className="list-group list-group-flush mb-3">
                                {positionRow("fa-solid fa-calendar-days", "Closing date", positionFullDetails.Details.ClosingDate)}
                                {positionFullDetails.Features.Positions_PQE_ShowExternally && positionRow("fa-solid fa-business-time", "PQE", positionFullDetails.Details.PQERequired)}
                                {positionRow("fa-solid fa-lightbulb", "Experience level", positionFullDetails.Details.ExperienceLevel)}
                                {positionRow("fa-solid fa-timeline", "Term type", positionFullDetails.Details.TermType)}
                                {positionRow("fa-solid fa-hourglass-start", "Duration", positionFullDetails.Details.Duration)}
                                {positionFullDetails.Features.Positions_Salary_ShowExternally && positionRow("fa-solid fa-wallet", "Salary", positionFullDetails.Details.Salary)}
                                {positionRow("fa-solid fa-clock", "Working hours", positionFullDetails.Details.JobHours)}
                                {positionRow("fa-solid fa-people-roof", "Reports to", positionFullDetails.Details.ReportsTo)}
                                {positionRow("fa-solid fa-hashtag", "Job ref", positionFullDetails.Details.JobRef)}
                                {positionRow("fa-solid fa-building-columns", app.positions.Features.DisplayText_Department, positionFullDetails.Details.ExternalDepartment)}
                                {app.positions.Features.JobBoard_PracticeGroup && positionRow("fa-solid fa-building-columns", app.positions.Features.DisplayText_PracticeGroup, position.PracticeGroup)}
                                {positionRow("fa-solid fa-location-dot", "Location", positionFullDetails.Details.LocationText)}
                                {positionRow("fa-solid fa-book", "Specialism", positionFullDetails.Details.Specialism)}
                                {positionFullDetails.Features.Intranet_HMN_ShowExternally && positionRow("fa-solid fa-building-user", "Hiring manager", positionFullDetails.Details.HiringManagerName)}
                            </ul>
                        }
                        {positionFullDetails != null && positionFullDetails.Sections.map(x => {
                            return <Fragment key={`Section_${x.SectionHeader}`} >
                                {(x.SectionText != null && x.SectionText.length > 0 && x.SectionText.trim().length > 0 && <>
                                    <CardDivider key={`SectionHeader_${x.SectionHeader}`} title={x.SectionHeader} icon={null} />
                                    <div key={`SectionDetails_${x.SectionHeader}`} className="mb-3" dangerouslySetInnerHTML={{ __html: x.SectionText }}></div>
                                </>) }
                            </Fragment>
                        })}
                    </LoadingContent>
                </div>
            </div>
            {!loadingDetails &&
                (positionFullDetails?.ExistingApplications != null && positionFullDetails?.ExistingApplications.length > 0) &&
                app.userLoggedIn &&
                positionFullDetails?.Check?.Details?.DateConfirmed == null &&
                positionFullDetails?.Check?.Details?.ApplicationNumber == null &&
                positionFullDetails.CanApply &&
                <CreateApplicationCard ExistingApplications={positionFullDetails.ExistingApplications} setExistingToCopy={setExistingToCopy} existingToCopy={existingToCopy} />
            }

            {!props.intra && <Link to="/" className="btn btn-outline-soft">Back</Link>}
            {props.intra && <Link to="/intranet" className="btn btn-outline-soft">Back</Link>}
            <span className="text-end float-end button-bottom-row-sticky">
                {applyButton(refId, positionFullDetails, app.userLoggedIn, redirectChecking, app.loggedInUser.UserType, existingToCopy, props.intra && app?.baseFeatures?.IsIntranetDisplay, redirectOrCreateCheck)}
            </span>
        </>
    );
}

const positionRow = (iconClass: string, title: string, details: string) => {
    if (details == null || details.length == 0 || details == '')
        return null;
    return (<li key={`DR_${title}`} className="list-group-item d-flex"><div className="w-50 text-alt-or-contrast"><i className={`icon-squared me-1 fa-solid ${iconClass}`}></i><b>{title}:</b> </div><div className="w-50">{details}</div></li>);
}

const applyButton = (refId: string, positionFullDetails: PositionContainerModel, userLoggedIn: boolean, redirectChecking: boolean, userType: UserType, existingToCopy: number | null, intra: boolean, redirectOrCreateCheck: () => void) => {
    if (positionFullDetails == null)
        return null;

    if (positionFullDetails.Features.Intranet_ShortForm && intra)
        return <Link to={`/intranet/apply?id=${refId}`} className="btn btn-alt">Apply internally</Link>

    if (!userLoggedIn)
        return <button type="button" className="btn btn-alt" data-bs-toggle="modal" data-bs-target="#loginPromptModal">Apply</button>;

    if (userLoggedIn && userType != UserType.Candidate) {
        if (!positionFullDetails.CanApply) // position cannot be applied to
            return null;

        if (positionFullDetails.Check != null && positionFullDetails.Check.Details != null && positionFullDetails.Check.Details.DateConfirmed != null) // has completed application
            return <a className="btn btn-alt" target="_blank" href={`/Preview/?app=${positionFullDetails.Check.Details.ApplicationNumber}`}>Candidate submitted, view application</a>;

        return <button disabled={redirectChecking} className="btn btn-alt" onClick={e => { e.preventDefault(); redirectOrCreateCheck(); }}>Put forward candidate</button>
    }

    if (positionFullDetails.Check != null && positionFullDetails.Check.Details != null) {
        if (positionFullDetails.Check.Details.DateConfirmed != null) // has completed application
            return <a className="btn btn-alt" target="_blank" href={`/Preview/?app=${positionFullDetails.Check.Details.ApplicationNumber}`}>View application</a>;

        if (!positionFullDetails.CanApply) // position cannot be applied to
            return null;

        if (positionFullDetails.Check.Details.ApplicationNumber != null)
            return <a className="btn btn-alt" href={`/Form/?r=${positionFullDetails.Check.Details.ApplicationNumber}`}>Continue application</a>;
    }

    return <button disabled={redirectChecking} className="btn btn-alt" onClick={e => { e.preventDefault(); redirectOrCreateCheck(); }}>{existingToCopy == null ? "Apply" : "Apply and copy existing"}</button>
}
